<template>
  <div class="statBlock-container">
    <div v-if="loading" class="d-flex align_center justify_center full-height">
      <NumeraiLoader />
    </div>
    <div v-else class="statBlock space_between">
      <div class="flex_col align_center">
        <div>
          <div v-if="label" class="label">
            {{ label }}
          </div>
          <div v-if="sublabel" class="sublabel">
            {{ sublabel }}
          </div>
        </div>
        <NumeraiTooltip v-if="valueTooltip && value" :text="valueTooltip">
          <div
            class="value stat-block"
            :class="{
              'color-nmr': nmr,
              'color-positive': positive,
              'color-negative': negative,
              'color-subtle': invalid,
            }"
          >
            {{ formattedValue }}
          </div>
        </NumeraiTooltip>
        <div
          v-else-if="value"
          class="value stat-block"
          :class="{
            'color-nmr': nmr,
            'color-positive': positive,
            'color-negative': negative,
            'color-subtle': invalid,
          }"
        >
          {{ formattedValue }}
        </div>
        <div v-else class="value empty">
          -
        </div>
        <div v-if="subvaluelabel" class="sublabel">
          {{ subvaluelabel }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeMinusSign } from '@/lib/utils'
export default {
  components: {
    NumeraiLoader: () => import('@/components/shared/NumeraiLoader'),
    NumeraiTooltip: () => import('@/components/shared/NumeraiTooltip'),
  },
  props: {
    label: { type: String, default: '' },
    sublabel: { type: String, default: '' },
    value: { type: [String, Number], default: '' },
    valueTooltip: { type: String, default: null },
    loading: { type: Boolean, default: false },
    subvaluelabel: { type: String, default: '' },
    nmr: { type: Boolean, default: false },
    positive: { type: Boolean, default: false }, // Green
    negative: { type: Boolean, default: false }, // Red
    delta: { type: Boolean, default: true }, // Show up/down arrow
    invalid: { type: Boolean, default: false },
  },
  computed: {
    formattedValue() {
      if (this.delta) {
        return removeMinusSign(this.value)
      } else {
        return this.value
      }
    },
  },
}
</script>

<style scoped>
.statBlock-container {
  height: 120px;
}

.statBlock {
  display: flex;
  flex-direction: column;
  padding: 20px 17px 10px;
  font-family: var(--ui-font);
}

.delta.stat-block::before {
  font-size: 15px;
  padding-right: 5px;
  padding-bottom: 0;
}

.label {
  color: var(--color-secondary);
  font-family: var(--ui-font);
  font-size: 20px;
  font-weight: 600;
  margin-bottom: -8px;
}

.brand-label .label {
  font-weight: 700;
  font-size: 16px;
}

.sublabel {
  color: var(--color-tertiary);
  font-size: 14px;
  font-weight: 500;
  margin-top: 2px;
  margin-bottom: 10px;
}

.value {
  display: flex;
  align-items: center;
  height: 80px;
  font-size: 44px;
  color: var(--color-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-family: var(--number-font);
}

.empty {
  color: var(--color-subtle);
}
</style>
